import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-4">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors no-underline">
                首页
              </Link>
              <span>/</span>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于我们
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                火影同人游戏合集，致力于为火影忍者粉丝打造最全面、最优质的火影同人游戏导航平台
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center mb-14">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  我们的使命
                </h2>
                <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    火影同人游戏合集成立于2024年，是中文互联网上最专业的火影同人游戏导航平台之一。
                    我们深知每一位火影忍者粉丝对忍者世界的热爱，因此我们精心筛选和整理了数百款优质的火影同人游戏，
                    涵盖角色扮演、格斗对战、策略养成、冒险探索等多种玩法类型。
                  </p>
                  <p>
                    无论你是想体验火影同人角色扮演游戏的沉浸式剧情，还是寻找火影同人格斗游戏的热血对战，
                    亦或是喜欢火影同人手游的便捷畅玩，我们的平台都能为你提供最精准的游戏推荐。
                  </p>
                  <p>
                    我们坚持收录高质量的火影同人免费游戏，让每一位玩家都能无门槛地体验忍者世界的魅力。
                    同时，我们也不断更新火影同人游戏相关的攻略、资讯和评测内容，帮助玩家更好地享受游戏乐趣。
                  </p>
                </div>
              </div>

              <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20warm%20and%20cozy%20game%20community%20hub%2C%20people%20gathered%20around%20a%20large%20screen%20displaying%20colorful%20game%20art%2C%20friendly%20atmosphere%2C%20modern%20indoor%20space%2C%20warm%20orange%20and%20cream%20tones%2C%20soft%20lighting%2C%20community%20spirit&width=800&height=600&seq=about-mission&orientation=landscape"
                  alt="火影同人游戏合集 - 我们的使命"
                  title="火影同人游戏合集 - 品牌介绍"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                我们的优势
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: '品质精选',
                  desc: '每款火影同人游戏都经过团队人工评测，确保游戏品质和可玩性，拒绝低质量内容。',
                },
                {
                  icon: 'ri-refresh-line',
                  title: '持续更新',
                  desc: '每日更新火影同人游戏资源，第一时间收录最新发布的优质火影同人游戏作品。',
                },
                {
                  icon: 'ri-user-heart-line',
                  title: '玩家至上',
                  desc: '以火影粉丝的需求为核心，提供最精准的火影同人游戏分类和个性化推荐。',
                },
                {
                  icon: 'ri-shield-star-line',
                  title: '安全可靠',
                  desc: '所有推荐的游戏均经过安全检测，确保玩家的设备和数据安全，放心畅玩。',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center"
                >
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className={`${item.icon} text-xl text-accent-600`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 text-base mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                玩家口碑
              </h2>
              <p className="mt-3 text-sm text-foreground-600">来自火影同人游戏玩家的真实评价</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  name: '鸣人粉丝123',
                  avatar: 'N',
                  rating: 5,
                  comment: '这个网站太棒了！终于找到了一个专门收集火影同人游戏的平台，分类清晰，游戏质量都很高，尤其是火影同人角色扮演游戏那块，推荐了好几款我超爱的作品。',
                },
                {
                  name: '忍术大师',
                  avatar: '忍',
                  rating: 5,
                  comment: '火影同人格斗游戏爱好者必收藏的网站！推荐的格斗游戏都很硬核，连招系统做得非常还原，在线对战也很流畅。强烈推荐给喜欢竞技的玩家。',
                },
                {
                  name: '木叶村居民',
                  avatar: '木',
                  rating: 5,
                  comment: '作为火影同人手游的重度玩家，这个平台的手机游戏推荐非常精准。通勤路上玩的火影同人免费游戏都是从这里找的，品质都很有保证。',
                },
                {
                  name: '佐助的小迷妹',
                  avatar: '佐',
                  rating: 4,
                  comment: '攻略文章写得很详细，新手入门指南帮了我大忙。火影忍者同人RPG的上手指南尤其有用，推荐给刚入坑的玩家。',
                },
                {
                  name: '晓组织成员',
                  avatar: '晓',
                  rating: 5,
                  comment: '更新速度很快，新出的火影同人游戏基本隔天就能在网站上看到。游戏评测也很专业，帮我避了不少雷。火影同人游戏下载指引也很清晰。',
                },
                {
                  name: '忍界观察员',
                  avatar: '观',
                  rating: 5,
                  comment: '火影同人游戏最全的导航站没有之一！从格斗到策略到角色扮演，各种类型的火影同人游戏应有尽有。社区氛围也很好，推荐！',
                },
              ].map((review, idx) => (
                <div
                  key={idx}
                  className="bg-background-100 rounded-lg border border-background-200/70 p-5"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center font-heading font-bold text-primary-700 text-sm">
                      {review.avatar}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <div key={i} className="w-3 h-3 flex items-center justify-center">
                            <i
                              className={`${
                                i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                              } text-xs`}
                            ></i>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {review.comment}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                联系我们
              </h2>
              <p className="mt-3 text-sm text-foreground-600">
                有任何关于火影同人游戏的问题或建议，欢迎随时联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">电子邮箱</h3>
                <p className="text-xs text-foreground-600">contact@naruto-fangame.com</p>
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-chat-smile-2-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">社群交流</h3>
                <p className="text-xs text-foreground-600">加入我们的Discord社群，与其他火影粉丝交流</p>
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-message-3-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 mb-2">微信公众号</h3>
                <p className="text-xs text-foreground-600">搜索"火影同人游戏"关注我们</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 火影同人游戏合集',
            description: '火影同人游戏合集致力于为火影忍者粉丝打造最全面的火影同人游戏导航平台，涵盖角色扮演、格斗、策略等多种玩法。',
            url: 'https://naruto-fangame.com/about',
            mainEntity: {
              '@type': 'Organization',
              name: '火影同人游戏合集',
              description: '火影同人游戏合集是中文互联网上最专业的火影同人游戏导航平台，提供火影同人游戏推荐、攻略资讯和下载指引。',
              url: 'https://naruto-fangame.com/',
              email: 'contact@naruto-fangame.com',
              foundingDate: '2024',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://naruto-fangame.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}